'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = exports.Table = void 0;
/**
 * DynamoDB Toolbox: A simple set of tools for working with Amazon DynamoDB
 * @author Jeremy Daly <jeremy@jeremydaly.com>
 * @version 0.3.0
 * @license MIT
 */
// TODO: Check param merging
// TODO: 'Remove null fields' option
// TODO: prevent reserved field names?
const Table_1 = __importDefault(require("./classes/Table"));
exports.Table = Table_1.default;
const Entity_1 = __importDefault(require("./classes/Entity"));
exports.Entity = Entity_1.default;
